require('./bootstrap');

$('.center').slick({
  arrows: false,
  dots: false
});

$('.region-faq .right .important-questions .question h3').click(function() {
  $(this).parent().addClass('active').siblings().removeClass('active');
});

$('.region-news .right .important-news .news h3').click(function() {
  $(this).parent().addClass('active').siblings().removeClass('active');
});

$('.region-seminar-content .content-detail h3').click(function() {
  $(this).parent().addClass('active').siblings().removeClass('active');
});


$('.region-our-services .row .col-inner').click(function() {
  $(this).addClass('active').parent().siblings().find(".col-inner").removeClass('active');
  var active_class = "." + $(this).attr('id');
  $(active_class).addClass('active');
  $(active_class).siblings().removeClass('active');
});

$('.partners-slider').slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 5,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true
      }
    }
  ]
});

$('.region-why-choose-us .row').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
  ]
});

